/**
 * Auto-detect API URL based on current hostname
 * Works for both localhost and network IP addresses
 */

export const getApiUrl = (): string => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//localhost:8000`;
  }

  // Check if hostname is an IP address
  const isIp = /^[0-9.]*$/.test(hostname);

  // If it's an IP, use port 8000 (direct access without domain configuration)
  if (isIp) {
    return `${protocol}//${hostname}:8000`;
  }

  // Production with domain (e.g. bk.paytakht-mic.com)
  // Use the same protocol and hostname without port suffix
  // Requests will go to standard 80/443 and be handled by Nginx proxy
  return `${protocol}//${hostname}`;
};

export const getApiBaseUrl = (): string => {
  return `${getApiUrl()}/api`;
};

// Debug function to log current configuration
export const logApiConfig = (): void => {
  // API configuration logging removed for performance
};
